import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import * as shortId from 'shortid'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export default async function importMediaItem (data) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('MediaItems')

  const globalId = shortId.generate()
  try {
    savingStart()
    await collectionReference.doc(globalId).set({
      ...data,
      content: typeof data.content === 'object' ? JSON.stringify(data.content) : data.content,
      type1Order: data.type1Order || 0,
      creationTimeValue: (Math.floor(Date.now() * 0.001)),
      id: globalId,
      localId: data.id,
      inType1Items: true
    })
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'importData.js')
  }
}
